import React, { useEffect, useState } from "react";
import axiosInstance, { handleApiError } from "../../../services/axiosService";
import { useAPIContext } from "../../../context/APIContext";
import Loader from "../../../Layouts/Loader/Loader";
import WebhookApiEditor from "./WebhookApiEditor";
import ErrorMessage from "../../../components/FormComponents/ErrorMessage";

const WebhookApiSection = (props) => {
  const { selectedApiData, setSelectedApiData } = useAPIContext();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const { file } = props;

  useEffect(() => {
    const fetchWebhook = async (id, endPoint) => {
      try {
        setIsLoading(true);
        const { data } = await axiosInstance.get(`/${endPoint}/${id}`);
        const processedData = {
          ...data,
          projections: JSON.stringify(data.projections, null, 2),
          body: JSON.stringify(data.body, null, 2)
        };
        setSelectedApiData(processedData);
        setIsLoading(false);
      } catch (error) {
        handleApiError(error);
        setIsLoading(false);
        setError(error);
      }
    };

    if (file.id) {
      fetchWebhook(file.id, "webhook");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file.id]);

  if (isLoading) {
    return <Loader />;
  }
  if (error) {
    return (
      <div className="d_flex justify_center align_center h_100">
        <ErrorMessage>{error}</ErrorMessage>
      </div>
    );
  }
  if (!selectedApiData) return null;

  return <WebhookApiEditor file={file} selectedApiData={selectedApiData} setSelectedApiData={setSelectedApiData} />;
};

export default WebhookApiSection;
